import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "date-filter" }
const _hoisted_2 = { style: {"display":"flex","flex-direction":"row","gap":"15px"} }

import { ref, watch } from 'vue';
import DatePicker from 'vue-datepicker-next';
import { formatDateTime } from "@/filters";
import Config from '@/config';


export default /*@__PURE__*/_defineComponent({
  __name: 'CreatedAtFilter',
  props: {
  searchParams: {
    type: Object,
    required: true,
  },
},
  setup(__props) {



const afterBorder = ref(__props.searchParams['after']);
const beforeBorder = ref(__props.searchParams['after']);
const lang = Config.getUser().getLang();

watch(
  afterBorder,
  (newValue?: string) => {
    if (newValue) {
      __props.searchParams['event.createdAt[after]'] = formatDateTime(newValue);

	  return;
	}
    delete __props.searchParams['event.createdAt[after]'];
  },
);
watch(
  beforeBorder,
  (newValue?: string) => {
    if (newValue) {
      const beforeDate = new Date(newValue);
      beforeDate.setHours(23, 59, 59, 999);
      __props.searchParams['event.createdAt[before]'] = formatDateTime(beforeDate.toISOString());

	  return;
	}
    delete __props.searchParams['event.createdAt[before]'];
  },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createTextVNode(_toDisplayString(_ctx.$t('Дата')), 1 /* TEXT */),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(DatePicker), {
        placeholder: _ctx.$t('С'),
        type: "date",
        class: "date-period",
        value: afterBorder.value,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((afterBorder).value = $event)),
        lang: _unref(lang)
      }, null, 8 /* PROPS */, ["placeholder", "value", "lang"]),
      _createVNode(_unref(DatePicker), {
        placeholder: _ctx.$t('По'),
        type: "date",
        class: "date-period",
        value: beforeBorder.value,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((beforeBorder).value = $event)),
        lang: _unref(lang)
      }, null, 8 /* PROPS */, ["placeholder", "value", "lang"])
    ])
  ]))
}
}

})